import moment from 'moment';

/**
 * Sets user data into local storage
 * @param {object} data of the form {"first_name", "last_name", "email", "linkedin"} 3/15/21
 * @param {string} token jwt token
 * @param {string} lastLogin "auth0" or "email"
 * @param {string} token_exp token expiration date
 */
export const setUserDataLocalStorage = (data, token, refreshToken, lastLogin = null, tokenExp) => {
  localStorage.setItem("token", token);
  localStorage.setItem("refreshToken", refreshToken);
  localStorage.setItem("user", JSON.stringify(data));
  lastLogin && localStorage.setItem("lastLogin", JSON.stringify({ lastLogin, email: data.email }));
  localStorage.setItem("tokenExp", moment(tokenExp).format("YYYY-MM-DD HH:mm:ss"))
};

/**
 * Sets user data into local storage
 * @param {object} data of the form {"link", "dateSubmitted", "pod"} 3/15/21
 */
export const setLinkDataLocalStorage = (data) => {
  localStorage.setItem("link", JSON.stringify(data));
};

export const setStatsLocalStorage = (data) => {
  localStorage.setItem("stats", JSON.stringify(data));
};

export const setGeneratedResponsesLocalStorage = (responsesArray) => {
  localStorage.setItem("generated-responses", JSON.stringify(responsesArray));
};

export const deleteLinkDataLocalStorage = () => {
  localStorage.removeItem("link");
};

export const deleteGeneratedResponsesLocalStorage = () => {
  localStorage.removeItem("generated-responses");
};

export const deleteLocalStorage = () => {
  localStorage.removeItem("link");
  localStorage.removeItem("token");
  localStorage.removeItem("user");
  localStorage.removeItem("stats");
};
